import { Fragment } from "react";
import { Skills } from "./UI/ContentBlocks";
import { TitleButton } from "./UI/Title";
import { Container } from "@mui/material";
import { TeachersGuide } from "./websiteContent";
import Banner from "./UI/Banner";

const TeacherGuide = () => {
  const root = TeachersGuide;
  return (
    <Fragment>
      <Banner />
      <Container fixed>
        <div>
          <section>
            <TitleButton
              title={root.title.title}
              paragraph={root.title.paragraph}
            />
            <Skills content={root.content} />
          </section>
        </div>
      </Container>
    </Fragment>
  );
};

export default TeacherGuide;
